import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  input,
  Input,
  output,
} from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { TranslatePipe } from '@ngx-translate/core';
import { LastUpdatePipe } from '@wilson/pipes';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'wilson-last-update-status',
  templateUrl: './last-update-status.component.html',
  styleUrls: ['./last-update-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslatePipe, LastUpdatePipe, FontAwesomeModule, NzTooltipModule],
})
export class LastUpdateStatusComponent {
  private cdRef = inject(ChangeDetectorRef);

  @Input() updatedAt: string | undefined;
  @Input() set isUpdated(isChanged: boolean) {
    if (isChanged) {
      this.isChanged = true;
      this.cdRef.detectChanges();
      setTimeout(() => {
        this.isChanged = false;
        this.cdRef.detectChanges();
      }, 2000);
    }
  }
  readonly isClickable = input<boolean>(false);
  readonly clickEvent = output<void>();

  isChanged = false;

  readonly faCheckCircle = faCheckCircle;
}
